import { Box, Grid, IconButton, TextField } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { Email } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import styles from "./styles";

interface Props {
  scheduledEmail: Email;
  setScheduledEmail: Dispatch<SetStateAction<Email | undefined>>;
}

const ScheduledEmailSubject = ({
  scheduledEmail,
  setScheduledEmail,
}: Props) => {
  const subject = scheduledEmail?.subject?.replace(/(<([^>]+)>)/gi, "");

  const [isEditing, setIsEditing] = useState(false);

  if (isEditing) {
    return (
      <Grid container alignItems="center">
        <TextField
          variant="standard"
          value={subject}
          onChange={(e: CustomEvent) => {
            const { value } = e.target;
            setScheduledEmail((prev) => {
              if (prev) {
                return {
                  ...prev,
                  subject: value,
                  isChanged: true,
                };
              }
              return prev;
            });
          }}
          InputProps={{
            sx: (theme) => ({
              fontSize: theme.typography.h6.fontSize,
              fontWeight: theme.typography.h6.fontWeight,
              fontFamily: theme.typography.h6.fontFamily,
              lineHeight: theme.typography.h6.lineHeight,
              letterSpacing: theme.typography.h6.letterSpacing,
            }),
          }}
          sx={{
            px: 2,
            width: { xs: 300, md: 500 },
          }}
          onBlur={() => {
            if (subject) {
              setIsEditing(false);
            }
          }}
          onKeyDown={(e: CustomEvent) => {
            if (e.key === "Enter") {
              if (subject) {
                setIsEditing(false);
              }
            }
          }}
        />

        <IconButton sx={styles.editButton} onClick={() => setIsEditing(false)}>
          <Box component="i" className="fa-regular fa-check" />
        </IconButton>
      </Grid>
    );
  }

  return (
    <Box sx={{ ml: 2, fontSize: 20, fontWeight: 600 }}>
      {subject}{" "}
      <IconButton sx={styles.editButton} onClick={() => setIsEditing(true)}>
        <Box component="i" className="fa-regular fa-pen" />
      </IconButton>
    </Box>
  );
};

export default ScheduledEmailSubject;
